import { RootState } from "@/store/dtm";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OnlineAccountDetailType } from "@/lib/DTMWebAPIClient.generated";



export interface referralProductState {
    products: OnlineAccountDetailType[],
}

const initialState: referralProductState = {
    products: []
}

export const referralProductSlice = createSlice({
    name: "referralProductSlice",
    initialState,
    reducers: {
        setReferralProducts: (state, action: PayloadAction<OnlineAccountDetailType[]>) => {
            state.products = action.payload;
        },
        clearReferralProductsState: (state) => {
            state.products = [];
        }
    }
});

export const {
    setReferralProducts, clearReferralProductsState
} = referralProductSlice.actions;

export const selectReferralProducts = (state: RootState) => state.referralProducts.products;

export default referralProductSlice.reducer